import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const LabelText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.muted};
  font-weight: 600;
  line-height: 1.2;
`

const ValueText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.text};
  font-weight: 500;
  line-height: 1.3;
  word-break: break-word;
`

export function LabelValue({ label, value, style, labelStyle, valueStyle }) {
  return (
    <Wrapper style={style}>
      <LabelText style={labelStyle}>{label}</LabelText>
      <ValueText style={valueStyle}>{value}</ValueText>
    </Wrapper>
  )
}
